require('./hiringProductInformation.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @actions
const hiringProductInformation = require('actions/hiringProductInformation')

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ components
const HiringProductInformationAdvantages = require('./hiringProductInformationAdvantages');
const HiringProductInformationCharacteristics = require('./hiringProductInformationCharacteristics');
const HiringProductInformationPrecontractualLinks = require('./hiringProductInformationPrecontractualLinks');
const HiringProductInformationFaq = require('./hiringProductInformationFaq');

class HiringProductInformation extends React.Component {

    componentDidMount() {
        const { getHiringProductInformation, productAlias, productComponentId } = this.props;
        const requestedProducts = [
            {
                alias: productAlias
            }
        ]
        getHiringProductInformation(requestedProducts, productComponentId);
    }

    render() {
        const { immHiringProductInformation, precontractualLinkTarget } = this.props;
        let content;
        if (immHiringProductInformation.get('isFetching')) {
            content = (<LoadingSection />)
        } else if (immHiringProductInformation.get('error')) {
            const emptyStateTitle = formatText('hireInformationComponent-emptyStateTitle');
            const emptyStateText = formatText('hireInformationComponent-emptyStateText');
            content = <EmptyState title={emptyStateTitle} primaryText={emptyStateText} iconType="nointernet-banking" />;
        } else if (immHiringProductInformation.get('success')) {
            const immAdvantages = immHiringProductInformation.get('advantages');
            const immCharacteristics = immHiringProductInformation.get('characteristics');
            const immPrecontractualLinks = immHiringProductInformation.get('precontractualLinksList');
            const immRiskLevel = immHiringProductInformation.get('riskLevelsContent');
            const immRiskLiquidityAlert = immHiringProductInformation.get('riskLiquidityAlertContent');
            const title = immHiringProductInformation.getIn(['description', 'processed']);
            const immFaqs = immHiringProductInformation.get('faqs');
            content = (
                <div className="hiring-product-information public-cms-styles">
                    <div className="hiring-product-information__header">
                        <HTMLSafeInjector
                            message={title}
                        />
                    </div>
                    <div className="container-fluid hiring-product-information__advantages">
                        <HiringProductInformationAdvantages
                            immAdvantages={immAdvantages}
                            immRiskLevel={immRiskLevel}
                            immRiskLiquidityAlert={immRiskLiquidityAlert}
                        />
                    </div>
                    <HiringProductInformationCharacteristics
                        immCharacteristics={immCharacteristics}
                    />
                    <HiringProductInformationFaq
                        immFaqs={immFaqs}
                    />
                    <div className="hiring-product-information__footer-links">
                        <HiringProductInformationPrecontractualLinks
                            precontractualLinks={immPrecontractualLinks}
                            precontractualLinkTarget={precontractualLinkTarget}
                        />
                    </div>
                </div >
            )
        }
        return (
            <div className="hiring-product-information">
                {content}
            </div>
        );
    }
}

HiringProductInformation.propTypes = {
    getHiringProductInformation: PropTypes.func,
    immHiringProductInformation: PropTypes.object,
    productAlias: PropTypes.string.isRequired,
    productComponentId: PropTypes.number.isRequired,
    precontractualLinkTarget: PropTypes.string,
};

module.exports = connect(
    state => ({
        immHiringProductInformation: state.hiringProductInformation,
    }),
    {
        getHiringProductInformation: hiringProductInformation.getHiringProductInformation,
    }
)(HiringProductInformation);
